// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__5_JPr","productName":"Table_productName__2JnvJ"};